<div class="px-3 pt-3 pb-2">
  <div class="flex items-center justify-between gap-3 mb-2">
    <span class="text-xs text-gray-400 uppercase tracking-wide font-semibold">Concessionárias</span>
    <button type="button"
            class="text-xs font-semibold text-gray-400 hover:text-[#E41B2E] disabled:opacity-40 disabled:hover:text-gray-400 transition-colors"
            [disabled]="!hasSelection()"
            (click)="clear.emit()">
      Limpar seleção
    </button>
  </div>
  <div class="logo-grid">
    @for (c of visible(); track c.nome) {
      <button type="button"
              class="logo-btn"
              [class.active]="isSelected(c.nome)"
              [attr.aria-pressed]="isSelected(c.nome)"
              [title]="c.nome"
              (click)="toggle.emit(c.nome)">
        <span class="logo-code">{{ codeFor(c.nome) }}</span>
        @if (logoFor(c.nome); as logo) {
          <img [src]="logo" [alt]="c.nome">
          <span class="logo-name-overlay">{{ c.nome }}</span>
        } @else {
          <span class="logo-fallback-text">{{ c.nome }}</span>
        }
      </button>
    }
  </div>
</div>
